<script setup>
import { ref } from "vue";
import UserInfo from "./components/UserInfo.vue";

const activeClass = "js-active position-relative";
const activeStep = ref(0);
const formSteps = 3;

const nextStep = () => {
  if (activeStep.value < formSteps) {
    activeStep.value += 1;
  }
};
</script>
<template>
  <div class="row">
    <div class="col-12 col-lg-12">
      <form class="">
        <user-info :class="activeStep === 0 ? activeClass : ''" @next-step="nextStep" />
      </form>
    </div>
  </div>
</template>
